import { useEffect, useRef, memo } from "react";

/**
 * VTurb Smart Player embed.
 * Renders the <vturb-smartplayer> custom element and lazily injects
 * the converteai.net player script (only once per page load).
 */
const VTURB_ID = "vid-6a29c49e703fae361826c961";
const VTURB_SRC =
  "https://scripts.converteai.net/12c16187-ebaa-430c-bc3f-9601c00518f4/players/6a29c49e703fae361826c961/v4/player.js";

export default memo(function VTurbPlayer({ testId }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (document.querySelector(`script[src="${VTURB_SRC}"]`)) {
      return;
    }
    const s = document.createElement("script");
    s.src = VTURB_SRC;
    s.async = true;
    s.type = "text/javascript";
    document.head.appendChild(s);
  }, []);

  return (
    <div className="vturb-wrap" data-testid={testId} ref={containerRef}>
      <div
        dangerouslySetInnerHTML={{
          __html: `<vturb-smartplayer id="${VTURB_ID}" style="display:block;margin:0 auto;width:100%;"></vturb-smartplayer>`,
        }}
      />
    </div>
  );
})
